<template>
  <div class="card-footer">
    <div class="form-group">
      <div>{{ title }}</div>
      <br />
      <slot name="slot"></slot>
      <slot name="addID"></slot>
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
});
</script>
